import { createContext } from 'react';

export const FileHashContext = createContext('');
